import images from '../../constants/images';
export const skillSet = [
    {
        id: 1,
      name: 'React',
      img: images.react,
    },
    {
        id: 2,
        name: 'Figma',
        img: images.figma,
    },
    {
        id: 3,
        name: 'HTML',
        img: images.html,
    },
    {
        id: 3,
        name: 'css',
        img: images.css,
    },
    {
        id: 4,
        name: 'javascript',
        img: images.javascript,
    }
];

